import type { AbsenceDateElement, Task } from 'shared/graphql/graphql'

export const resolveTaskDates = (task: Task) =>
  task.taskData && 'dates' in task.taskData && task?.taskData?.dates
    ? task.taskData.dates.filter((date): date is AbsenceDateElement => date !== null)
    : []
